import { css } from '@emotion/react'
import { ButtonHTMLAttributes, FC } from 'react'

import Button from '~/form/components/atoms/Button'
import IconSend from '~/form/components/atoms/icons/IconSend'

export type Props = {
  icon?: string
} & ButtonHTMLAttributes<HTMLButtonElement>

const IconButton: FC<Props> = ({
  icon,
  children,
  disabled = false,
  ...rest
}) => {
  return (
    <Button css={icon && iconButtonStyle(disabled)} {...rest}>
      {disabled ? (
        <>
          <div css={LoadingStyle} />
        </>
      ) : (
        <>
          <span css={labelStyle}>{children}</span>
          {icon === 'send' && <IconSend css={iconSendStyle} />}
        </>
      )}
    </Button>
  )
}

export default IconButton

const LoadingStyle = () => css`
  width: 20px;
  height: 20px;
  margin: 0 auto;
  user-select: none;

  border: 4px rgba(255, 255, 255, 0.5) solid;
  border-top: 4px rgba(251, 226, 3.1, 0.5) solid;
  border-radius: 50%;
  animation: spCircRot 0.6s infinite linear;

  @keyframes spCircRot {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(359deg);
    }
  }
`

const iconButtonStyle = (disabled: boolean) => css`
  display: grid;
  grid-template-columns: ${disabled ? '1fr' : '1fr 51px'};
  grid-template-rows: auto;
  grid-template-areas: 'label after';

  @media (max-width: 767px) {
    grid-template-columns: 1fr 38px;
    gap: 8px;
  }
`

const labelStyle = css`
  grid-area: label;
  text-indent: 45px;

  @media (max-width: 767px) {
    text-indent: 17px;
  }
`

const iconSendStyle = css`
  margin-top: 4px;
  grid-area: after;

  @media (max-width: 767px) {
    width: 20px;
    height: 15px;
  }
`
